import React from "react";

function CmsServices() {
  return (
    <section className="section section--services --section-large-tb-padding">
      <div className="container">
        <div className="container__row --flex-center --section-small-tb-padding">
          <div className="container__col-md-5 container__col-xs-12 --section-large-tb-padding">
            <h2 className="container__heading">Hashout’s Headless CMS Services</h2>
            <div className="container__row">
              <div className="container__col-md-10">
                <div className="container__services">
                  <div className="container__row">
                    <div className="container__col-md-2 container__col-xs-2">
                      <img src="../../solutions/checkmark.png" alt="Hashout" />
                    </div>
                    <div className="container__col-md-10 container__col-xs-10">
                      <h5 className="container__sub-heading">
                        Headless CMS Product Evaluation
                      </h5>
                    </div>
                  </div>
                  <div className="container__row">
                    <div className="container__col-md-2  container__col-xs-2">
                      <img src="../../solutions/checkmark.png" alt="Hashout" />
                    </div>
                    <div className="container__col-md-10  container__col-xs-10">
                      <h5 className="container__sub-heading">
                        Content Models Design
                      </h5>
                    </div>
                  </div>
                  <div className="container__row">
                    <div className="container__col-md-2  container__col-xs-2">
                      <img src="../../solutions/checkmark.png" alt="Hashout" />
                    </div>
                    <div className="container__col-md-10  container__col-xs-10">
                      <h5 className="container__sub-heading">
                        Integration with Front-end
                      </h5>
                    </div>
                  </div>
                  <div className="container__row">
                    <div className="container__col-md-2  container__col-xs-2">
                      <img src="../../solutions/checkmark.png" alt="Hashout" />
                    </div>
                    <div className="container__col-md-10  container__col-xs-10">
                      <h5 className="container__sub-heading">
                        Hosting/Managed Services
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container__col-md-6 container__col-xs-12 container__col-md-offset-1 --flex-center">
            <img
              className="container__img --bg-absolute-right"
              src="../../solutions/platforms/headless-cms-services.png"
              alt="Adobe Commerce and Magento Services"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default CmsServices;
